import { Suspense, useEffect } from "react";
import "./App.css";
import { useLocation } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import AppRoutes from "./routes/Routes";
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import { Notifications } from "@mantine/notifications";

function App() {
  const location = useLocation();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <MantineProvider>
        <Notifications/>
      <AppRoutes key={location.pathname} />
      </MantineProvider>
    </Suspense>
  );
}

export default App;
